var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loads.length <= 2)?_c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.loads),function(load,i){return _c('v-col',{key:i,attrs:{"cols":"12","md":"6"}},[_c('BaseAddressCard',{attrs:{"color":"white","name":i === 0 ? _vm.$t('load.originAddress') : _vm.$t('load.deliveryTo'),"address":load.attributes.location}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }